<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row>
        <el-col :md="4" :lg="4">
          <el-input placeholder="手机号" v-model="mobile" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="4" :lg="4">
          <el-input placeholder="门店ID" v-model="distributorId" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="8" :lg="8">
          <el-date-picker v-model="created" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="dateChange" format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd" size="mini">
          </el-date-picker>
        </el-col>
      </el-row>
      <el-table :data="signinData" :height="wheight-210" v-loading="loading">
        <el-table-column prop="id" label="记录ID" width="90"></el-table-column>
        <el-table-column prop="user_id" label="会员ID" width="110"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="140"></el-table-column>
        <el-table-column prop="distributor_id" label="门店ID" width="100"></el-table-column>
        <el-table-column prop="store_name" label="门店名称" width="220"></el-table-column>
        <el-table-column prop="distance" label="距离(米)" width="110"></el-table-column>
        <el-table-column prop="longitude" label="经度" width="130"></el-table-column>
        <el-table-column prop="latitude" label="纬度" width="130"></el-table-column>
        <el-table-column prop="sign_date" label="签到日期" width="120">
          <template slot-scope="scope">
            {{signDateText(scope.row.sign_date)}}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="签到时间" width="180">
          <template slot-scope="scope">
            {{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total_count > params.pagesize" class="content-padded tc">
        <el-pagination background layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pagesize'>
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isMobile } from '../../../utils/validate'
import {
  storeSigninLogList
} from '../../../api/store_sign'

export default {
  data () {
    return {
      loading: false,
      total_count: 0,
      signinData: [],
      params: {
        page: 1,
        pagesize: 20
      },
      mobile: '',
      distributorId: '',
      created: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    getSigninList () {
      this.loading = true
      storeSigninLogList(this.params).then(response => {
        this.loading = false
        if (response.data.data && response.data.data.list) {
          this.signinData = response.data.data.list
          this.total_count = Number(response.data.data.total_count)
        } else {
          this.signinData = []
          this.total_count = 0
        }
      }).catch(() => {
        this.loading = false
      })
    },
    dateChange (val) {
      if (val && val.length > 0) {
        this.params.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
      this.params.page = 1
      this.getSigninList()
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str)) / 1000
    },
    // sign_date 是后端防重复签到的唯一索引字段，格式为 Ymd 整数（如 20260904）
    signDateText (val) {
      var text = String(val || '')
      if (text.length !== 8) {
        return '-'
      }
      return text.substr(0, 4) + '-' + text.substr(4, 2) + '-' + text.substr(6, 2)
    },
    keywordsSearch () {
      var mobile = String(this.mobile || '').trim()
      // 后端对 mobile 做精确匹配且会校验格式，不合法直接返回 422
      if (mobile && !isMobile(mobile)) {
        this.$message({ showClose: true, message: '请输入正确的11位手机号', type: 'warning' })
        return
      }
      this.params.page = 1
      this.params.mobile = mobile
      this.params.distributor_id = this.distributorId
      this.getSigninList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getSigninList()
    }
  },
  mounted () {
    this.getSigninList()
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// signinlist.vue?5487381c